import { Component, OnInit, TemplateRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs/Observable';
import { SharedService } from '../../common-app/service/shared.service';
import { DateUtil } from '../../common-app/util/date-util';
import { Constants } from '../../constants/constants';
import { Kvaw0510Service } from '../../service/kvaw0510.service';
import { Kvaw0510Vo } from '../../service/kvaw0510.vo';
import { OldReportViewModel } from '../kvap0600/kvap0600.view-model';
import { Kvap0700ViewModel } from './kvap0700.view-model';

@Component({
  templateUrl: './kvap0700.component.html',
  providers: [Kvaw0510Service],
})
export class Kvap0700Component implements OnInit {

  imageModalRef: BsModalRef;
  imageUrl: string;

  /** 画面表示用ViewModel */
  vModel: Kvap0700ViewModel;

  private oldReportParam: OldReportViewModel;

  constructor(
    private modalService: BsModalService,
    private location: Location,
    private router: Router,
    private sharedService: SharedService,
    private kvaw0510Service: Kvaw0510Service,
  ) { }

  ngOnInit() {
    // 過去日報一覧から連携されたパラメーターを取得
    this.oldReportParam = this.sharedService.get(Constants.SHARED_DATA_SAVE_KEY_OLD_REPORT_PARAM);
    // 過去日報詳細情報取得処理の呼出
    if (this.oldReportParam) {
      this.searchOldReportDetailActualObservable(this.oldReportParam.storeCode, this.oldReportParam.deliveryDate, this.oldReportParam.shimeiCode).subscribe((vo) => {
      });
    }
  }

  /**
   * 過去日報詳細情報を取得する（API呼出）
   * @param storeCode 相手先コード
   * @param deliveryDate 訪問年月日
   * @param shimeiCode 氏名コード
   */
  private searchOldReportDetailActualObservable(storeCode?: string, deliveryDate?: string, shimeiCode?: string): Observable<Kvaw0510Vo> {
    return this.kvaw0510Service.searchOldReportDetailActual(storeCode, deliveryDate, shimeiCode)
      .map(responseVo => {
        const receptionDate = this.oldReportParam.receptionDate;
        const receptionTime = this.oldReportParam.receptionTime;
        this.vModel = responseVo;
        this.vModel.formattedReceptionDate = DateUtil.formatYYYYMDddd(receptionDate);
        this.vModel.formattedReceptionTime = receptionTime && receptionTime.length > 4 ?
          receptionTime.substring(0, 2) + ':' + receptionTime.substring(2, 4) : receptionTime;
        this.vModel.storeName = this.oldReportParam.storeName;
        return responseVo;
      });
  }

  back() {
    this.location.back();
  }

  showImage(template: TemplateRef<any>, imageUrl: string) {
    this.imageUrl = imageUrl;
    this.imageModalRef = this.modalService.show(template, { ignoreBackdropClick: false, class: 'modal-dialog-centered' });
  }

  hideImage() {
    this.imageModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/component/kvap0700/kvap0700.component.ts